export default __webpack_public_path__ + "static/media/_DSC0827.432d926c.JPG";